module.exports = __webpack_public_path__ + "static/media/login-background.d402e06e.png";